import './SparePartsFilter.scss';

import { FilterFilled, FilterOutlined } from '@ant-design/icons';
import { useForm } from '@refinedev/antd';
import { Button, Form, Popover } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import AntdSelect from '@/components/general/AntdSelect/AntdSelect';
import FullscreenDrawer from '@/components/general/Drawers/FullscreenDrawer';
import { useUiContext } from '@/contexts/UiContext';
import { Shipment } from '@/model/Logistic/Shipment/Shipment';

import { useSparePartsFilter } from './useSparePartsFilter';

interface SparePartsFilterProps {
  filters: any[];
  setFilters: Function;
  setCurrent: Function;
}

const SparePartsFilter = (props: SparePartsFilterProps) => {
  const { t } = useTranslation();
  const { isMobile } = useUiContext();
  const [filterPopoverOpen, setFilterPopoverOpen] = useState(false);
  const { formProps } = useForm<Shipment>({ warnWhenUnsavedChanges: false });
  const { form } = formProps;
  const { filters, setFilters, setCurrent } = props;
  const { usersSelectProps, companySelectProps } = useSparePartsFilter(formProps, filters);
  const handleClearFilters = useCallback(() => {
    form?.resetFields();
    setFilters([], 'replace');
    setCurrent(1);
    setFilterPopoverOpen(false);
  }, [form, setCurrent, setFilters]);
  const applyFilters = useCallback(
    values => {
      const filters: any[] = [];

      // Empresa
      if (values.company) {
        filters.push({
          field: 'company',
          operator: 'eq',
          value: values.company,
        });
      }

      // Razon social
      if (values.shipment_payment_company) {
        filters.push({
          field: 'shipment_payment_company',
          operator: 'eq',
          value: values.shipment_payment_company,
        });
      }

      // Estado
      if (values.sale_items_state != undefined) {
        filters.push({
          field: 'sale_items_state',
          operator: 'eq',
          value: values.sale_items_state,
        });
      }

      // Creado por
      if (values.created_by) {
        filters.push({
          field: 'created_by',
          operator: 'eq',
          value: values.created_by,
        });
      }

      setFilters(filters, 'replace');
      setCurrent(1);
      setFilterPopoverOpen(false);
    },
    [setFilters, setFilterPopoverOpen, setCurrent],
  );
  const filterContent = useMemo(
    () => (
      <Form
        labelAlign="left"
        {...formProps}
        style={{ marginBottom: 8 }}
        onFinish={applyFilters}
        className="SparePartsFilterPopover">
        <div className="SparePartsFilterPopoverRows">
          <Form.Item label={t('Empresa')} name={'company'} className="SparePartsFilterRow">
            {/* <CompanySelector showFullName {...companySelectProps} allowClear showSearch /> */}
            <AntdSelect {...companySelectProps} allowClear showSearch />
          </Form.Item>
          <Form.Item
            label={t('Razon social')}
            name={'shipment_payment_company'}
            className="SparePartsFilterRow">
            {/* <CompanySelector showFullName {...companySelectProps} allowClear showSearch /> */}
            <AntdSelect {...companySelectProps} allowClear showSearch />
          </Form.Item>

          <Form.Item label={t('Creado por')} name={'created_by'} className="SparePartsFilterRow">
            <AntdSelect options={usersSelectProps.options} allowClear showSearch />
          </Form.Item>
          <Form.Item label={t('Estado')} name={'sale_items_state'} className="SparePartsFilterRow">
            <AntdSelect
              options={[
                { label: t('Gestión de pago'), value: 'payment_processing' },
                { label: t('Pagado'), value: 'paid' },
                { label: t('Cancelado'), value: 'canceled' },
              ]}
              allowClear
            />
          </Form.Item>
        </div>

        <div className="SparePartsFilterActions">
          <Button type="default" style={{ marginLeft: 8 }} onClick={() => handleClearFilters()}>
            {t('Limpiar')}
          </Button>
          <Button htmlType="submit" type="primary">
            {t('Buscar')}
          </Button>
        </div>
      </Form>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companySelectProps, usersSelectProps],
  );

  return (
    <div className="SparePartsFilter">
      {isMobile ? (
        <>
          <Button
            className={filters.length > 0 ? 'SparePartsFilterApplied' : ''}
            onClick={() => setFilterPopoverOpen(true)}
            icon={<FilterOutlined />}
          />
          <FullscreenDrawer
            disablePush
            title={t('Filtros')}
            open={filterPopoverOpen}
            setOpen={setFilterPopoverOpen}>
            {filterContent}
          </FullscreenDrawer>
        </>
      ) : (
        <Popover
          openClassName="SparePartsFilterPopover"
          content={filterContent}
          title={t('Filtros')}
          trigger="click"
          open={filterPopoverOpen}
          onOpenChange={setFilterPopoverOpen}
          placement="bottomRight">
          <Button
            className={filters.length > 0 ? 'SparePartsFilterApplied' : ''}
            icon={filters.length > 0 ? <FilterFilled /> : <FilterOutlined />}>
            {t('Filtrar')}
          </Button>
        </Popover>
      )}
    </div>
  );
};

export default SparePartsFilter;
